module.exports = __webpack_public_path__ + "static/media/virl_large.f9dd0cdf.png";